import NotActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveinitialInfo.svg?react';
import NotActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveContact.svg?react';
import ActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeContact.svg?react';
import ActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeinitialInfo.svg?react';
import { ADJUSTER_REPORT_DAMAGED_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';

export const otherDamagedSteperData = [
  {
    label: 'اطلاعات پایه',
    icon: <NotActiveinitialInfo />,
    activeIcon: <ActiveinitialInfo />,
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .otherDamaged,
  },
  {
    label: 'اطلاعات تماس',
    icon: <NotActiveContact />,
    activeIcon: <ActiveContact />,
    path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .otherDamagedContact,
  },
];
